import { z } from 'zod';
export const RiskIndicatorSchema = z.object({
    id: z.string()
}).passthrough();
export const RiskIndicatorsSchema = z.object({
    traffic: z.array(RiskIndicatorSchema).nullish(),
    companyReputation: z.array(RiskIndicatorSchema).nullish(),
    websiteReputation: z.array(RiskIndicatorSchema).nullish(),
    content: z.array(RiskIndicatorSchema).nullish(),
    pricing: z.array(RiskIndicatorSchema).nullish(),
    websiteStructure: z.array(RiskIndicatorSchema).nullish(),
    isWebsiteOffline: z.boolean().nullish()
}).passthrough().meta({
    id: 'RiskIndicators'
});

//# sourceMappingURL=risk-indicators.schema.js.map